export const extractAttributesValues = (attributes = [], attributesList) => {
  return attributes.reduce((acc, item) => {
    const { attribute_code, value } = item;

    if (attributesList.includes(attribute_code)) {
      acc[attribute_code] = value;
    }

    return acc;
  }, {});
};
